import store from "@/store";

const install = Vue => {
  Object.defineProperty(Vue.prototype, "$disaster", {
    get() {
      if (store.getters["defaultDisaster/disaster"]) {
        const disaster = store.getters["defaultDisaster/disaster"];
        if (typeof disaster.disaster_no !== "undefined") {
          return disaster;
        }
      }
      return null;
    },
    set(disaster) {
      store.dispatch("defaultDisaster/setDisaster", disaster);
    }
  });
};
export default {
  install
};
